import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { CompanyInsightsService } from 'src/app/_services/company-insights.service';

@Component({
    selector: 'app-company-comparison-details',
    templateUrl: './company-comparison-details.component.html',
    styleUrls: ['./company-comparison-details.component.scss'],
    standalone: false
})
export class CompanyComparisonDetailsComponent implements OnInit {

  constructor(private router: Router, private companyInsightsService: CompanyInsightsService) { }
  @Output() updateExport: EventEmitter<any> = new EventEmitter();
  export: boolean = false;

  ngOnInit() {
  }

  backToListing() {
    this.router.navigate(['/webbtree-company-list']);
  }

  exportOverview() {
    this.companyInsightsService.setCompanyExportData('true');
    this.export = true;
  }

}
